import React from 'react';
import { CheckCircle, Award, Users, Calendar, Target, Heart } from 'lucide-react';
import { companyInfo, teamMembers } from '../data/mock';
import Panama from "../Images/Panama5.webp";


export const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">Masonry Homes</span>
            </h1>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
              Founded in {companyInfo.founded}, we are a family business dedicated to building exceptional homes 
              and lasting relationships with our clients through quality craftsmanship and innovative design.
            </p>
          </div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
                Our Story
              </h2>
              <div className="space-y-6 text-gray-600">
                <p className="text-lg">
                  Masonry Homes LLC was born from a simple belief: every family deserves a home 
                  that reflects their dreams and values. What started as a small masonry company 
                  has grown into a trusted partner for homeowners throughout the region.
                </p>
                <p>
                  Our founder, Jaroslaw Moskal, began his career working alongside seasoned craftsmen 
                  who taught him that true quality comes from attention to detail, honest communication, 
                  and never cutting corners. These principles remain at the heart of everything we do today.
                </p>
                <p>
                  Over the years, we've expanded our services to include complete home renovations, 
                  custom new construction, and additions to projects. Despite our growth, we've maintained 
                  our commitment to treating every project - no matter the size - with the same level 
                  of care and professionalism.
                </p>
              </div>
            </div>

            <div className="relative">
              <img
                src={Panama}
                alt="Construction team at work"
                className="w-full h-96 object-cover rounded-xl shadow-lg"
              />
              <div className="absolute -bottom-6 -left-6 bg-orange-600 text-white p-6 rounded-xl">
                <div className="text-center">
                  <p className="text-2xl font-bold">{companyInfo.yearsExperience}</p>
                  <p className="text-sm">Years of Excellence</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Values */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Our Mission & Values
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We're guided by core principles that shape every decision and interaction.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-white rounded-xl p-8 shadow-sm">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Target size={28} className="text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Quality First</h3>
              <p className="text-gray-600">
                We never compromise on quality. Every material, every technique, and every detail 
                is chosen to ensure lasting results that exceed expectations.
              </p>
            </div>

            <div className="text-center bg-white rounded-xl p-8 shadow-sm">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Heart size={28} className="text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Customer Care</h3>
              <p className="text-gray-600">
                Your satisfaction is our success. We maintain open communication throughout 
                every project and stand behind our work with comprehensive warranties.
              </p>
            </div>

            <div className="text-center bg-white rounded-xl p-8 shadow-sm">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                <Award size={28} className="text-orange-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Innovation</h3>
              <p className="text-gray-600">
                We stay current with the latest construction techniques, materials, and 
                technologies to deliver modern solutions that enhance your living experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Meet Our Team
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Our experienced professionals bring decades of combined expertise to every project.
            </p>
          </div>
          {/*
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow duration-200">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-64 object-cover"
                />
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-1">{member.name}</h3>
                  <p className="text-orange-600 font-medium mb-3">{member.title}</p>
                  <p className="text-gray-600 text-sm">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
          */}

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow duration-200"
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className={`w-full h-64 object-cover ${member.imagePosition ?? "object-center"}`}
                />
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 mb-1">{member.name}</h3>
                    <p className="text-orange-600 font-medium mb-3">{member.title}</p>
                    <p className="text-gray-600 text-sm">{member.bio}</p>
                  </div>
              </div>
            ))}
          </div>


        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-orange-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
              Our Track Record
            </h2>
            <p className="text-xl text-orange-100">
              Numbers that speak to our commitment and success.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-white bg-opacity-20 rounded-xl p-6 mb-4">
                <Calendar size={32} className="text-white mx-auto" />
              </div>
              <p className="text-3xl font-bold text-white">{companyInfo.yearsExperience}</p>
              <p className="text-orange-100">Years Experience</p>
            </div>
            
            <div className="text-center">
              <div className="bg-white bg-opacity-20 rounded-xl p-6 mb-4">
                <Award size={32} className="text-white mx-auto" />
              </div>
              <p className="text-3xl font-bold text-white">{companyInfo.completedProjects}</p>
              <p className="text-orange-100">Projects Completed</p>
            </div>
            
            <div className="text-center">
              <div className="bg-white bg-opacity-20 rounded-xl p-6 mb-4">
                <Users size={32} className="text-white mx-auto" />
              </div>
              <p className="text-3xl font-bold text-white">{companyInfo.satisfiedClients}</p>
              <p className="text-orange-100">Happy Clients</p>
            </div>
            
            <div className="text-center">
              <div className="bg-white bg-opacity-20 rounded-xl p-6 mb-4">
                <CheckCircle size={32} className="text-white mx-auto" />
              </div>
              <p className="text-3xl font-bold text-white">95%</p>
              <p className="text-orange-100">Satisfaction Rate</p>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications & Licenses */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Certifications & Licenses
            </h2>
            <p className="text-xl text-gray-600">
              We maintain all necessary licenses and certifications to ensure your project is in good hands.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              'Licensed General Contractor',
              'Fully Bonded & Insured',
              'OSHA Safety Certified',
              'EPA RRP Certified',
              'Energy Star Partner',
              'Better Business Bureau A+',
              'Home Builders Association',
              'Local Building Permits'
            ].map((cert, index) => (
              <div key={index} className="bg-white rounded-lg p-4 text-center shadow-sm">
                <CheckCircle size={20} className="text-orange-600 mx-auto mb-2" />
                <p className="text-sm font-medium text-gray-700">{cert}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};